import React from 'react';
import RouteFooter from '../components/Footer';

export default function withRouteFooter(props) {
  return <RouteFooter {...props} />;
}
